module.exports = __webpack_public_path__ + "static/media/icon_up.c2fe4d22.svg";